module.exports = __webpack_public_path__ + "img/18.f1716e09.png";